import React, { useEffect, useState, useRef } from "react";

import * as Material from "@mui/material";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import './styles.css'

/**
 * paginationRef: {
 *    current: {
 *        currentPage: number
 *        total: number
 *        rowsPerPage: number
 *    }
 * }
 * 
 */

export default function PaginationBar({ paginationRef, setLoadingUsers, fullWidth=false }) {
  const containerRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      const container = containerRef.current;

      const element = document.getElementById(
        "btn-pagination-" + paginationRef?.current?.currentPage
      );
      if (container && element) {
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        const containerScrollLeft =
          elementRect.left -
          containerRect.left +
          elementRect.width / 2 -
          containerRect.width / 2;

        container.scrollTo({
          left: containerScrollLeft,
        });
      }
    }, 100);
  }, []);

  function ButtomComponent({ index }) {
    return (
      <Material.Button
        key={"btn-pagination-" + index}
        id={"btn-pagination-" + index}
        onClick={() => handleClickOnIndex(index)}
        className={
          "pagination-numer-btn " +
          (index === paginationRef?.current?.currentPage &&
            "current-pagination-btn")
        }
      >
        <Material.Typography variant="h5">{index}</Material.Typography>
      </Material.Button>
    );
  }

  if (
    !paginationRef?.current.currentPage ||
    paginationRef?.current.total <= paginationRef?.current.rowsPerPage ||
    !paginationRef?.current.total
  )
    return <></>;

  const paginationItems = Math.ceil(
    paginationRef?.current?.total / paginationRef?.current?.rowsPerPage
  );
  const paginationButtons = [];

  for (let i = 1; i < paginationItems + 1; i++) {
    const component = <ButtomComponent index={i} key={i} />;
    paginationButtons.push(component);
  }

  function handleClickPrevious() {
    if (paginationRef.current.currentPage === 1) return;
    paginationRef.current.currentPage = paginationRef.current.currentPage - 1;
    setLoadingUsers(true);
  }
  function handleClickNext() {
    if (paginationRef.current.currentPage === paginationItems) return;
    paginationRef.current.currentPage = paginationRef.current.currentPage + 1;
    setLoadingUsers(true);
  }
  function handleClickOnIndex(i) {
    paginationRef.current.currentPage = i;
    setLoadingUsers(true);
  }

  return (
    <div className={"pagination-bar "+(fullWidth && 'pagination-full-width')}>
      <Material.IconButton
        color="secondary"
        onClick={handleClickPrevious}
        className="pagination-prev pagination-btn"
      >
        <ArrowBackIosIcon />
      </Material.IconButton>
      <div ref={containerRef} className="pagination-pages-buttons fade">
        {paginationButtons}
      </div>
      <Material.IconButton
        color="secondary"
        onClick={handleClickNext}
        className="pagination-next pagination-btn"
      >
        <ArrowForwardIosIcon />
      </Material.IconButton>
    </div>
  );
}
